module.exports = __webpack_public_path__ + "2f54316bf645f2e07cccf325bfbc120e.pdf";